module.exports = __webpack_public_path__ + "media/images/amenities_icons/laundry_service-dd196aa7bae8dc1c722b4edf09e8a13c.svg";